// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  --box-shadow: none !important;
  box-shadow: 0px 4px 45px 0px rgba(0, 0, 0, 0.0784313725) !important;
}

ion-content {
  --padding-start: 16px;
  --padding-end: 16px;
  --padding-top: 16px;
  --padding-bottom: 16px;
  --background: var(--ion-color-primary);
}

.title {
  font-family: AppFontBold;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: 0;
  vertical-align: middle;
  text-transform: uppercase;
  margin-bottom: 16px;
}

.wrapper {
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(45%, 1fr));
  gap: 12px;
}
@media (min-width: 991px) {
  .wrapper {
    max-width: 1100px;
    grid-template-columns: repeat(auto-fill, minmax(20%, 1fr));
    margin: auto;
  }
}
.wrapper .item {
  min-height: 150px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px;
  border-radius: var(--radius-default);
  background: white;
  border: 0.5px solid var(--ion-color-tertiary);
}
.wrapper .item ion-img {
  width: 92%;
  max-height: 100px;
  object-fit: contain;
  margin-bottom: 16px;
}
.wrapper .item .name {
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 6px;
}
.wrapper .item .info {
  margin: 0;
  flex: 1;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  line-height: 110%;
  letter-spacing: 0;
  color: #656564;
}

.spinner-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/select-category/select-category.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,6BAAA;EACA,mEAAA;AADD;;AAIA;EACC,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,sCAAA;AAFD;;AAKA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,mBAAA;AAHD;;AAMA;EACC,WAAA;EACA,wBAAA;EAAA,mBAAA;EAEA,aAAA;EACA,0DAAA;EACA,SAAA;AAJD;AC5BE;ED0BF;IASE,iBAAA;IACA,0DAAA;IACA,YAAA;EAHA;AACF;AAKC;EACC,iBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,aAAA;EACA,oCAAA;EACA,iBAAA;EACA,6CAAA;AAJF;AAME;EACC,UAAA;EACA,iBAAA;EACA,mBAAA;EAEA,mBAAA;AALH;AAQE;EACC,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AANH;AASE;EACC,SAAA;EACA,OAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EAEA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AARH;;AAaA;EACC,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAVD","sourcesContent":["@use '../../../theme/mixins' as *;\n\nion-header {\n\t--box-shadow: none !important;\n\tbox-shadow: 0px 4px 45px 0px #00000014 !important;\n}\n\nion-content {\n\t--padding-start: 16px;\n\t--padding-end: 16px;\n\t--padding-top: 16px;\n\t--padding-bottom: 16px;\n\n\t--background: var(--ion-color-primary);\n}\n\n.title {\n\tfont-family: AppFontBold;\n\tfont-size: 20px;\n\tline-height: 120%;\n\tletter-spacing: 0;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\n\tmargin-bottom: 16px;\n}\n\n.wrapper {\n\twidth: 100%;\n\theight: fit-content;\n\n\tdisplay: grid;\n\tgrid-template-columns: repeat(auto-fill, minmax(45%, 1fr));\n\tgap: 12px;\n\n\t@include desktop {\n\t\tmax-width: 1100px;\n\t\tgrid-template-columns: repeat(auto-fill, minmax(20%, 1fr));\n\t\tmargin: auto;\n\t}\n\n\t.item {\n\t\tmin-height: 150px;\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\tpadding: 12px;\n\t\tborder-radius: var(--radius-default);\n\t\tbackground: white;\n\t\tborder: 0.5px solid var(--ion-color-tertiary);\n\n\t\tion-img {\n\t\t\twidth: 92%;\n\t\t\tmax-height: 100px;\n\t\t\tobject-fit: contain;\n\n\t\t\tmargin-bottom: 16px;\n\t\t}\n\n\t\t.name {\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: 0;\n\t\t\ttext-align: center;\n\t\t\tmargin-bottom: 6px;\n\t\t}\n\n\t\t.info {\n\t\t\tmargin: 0;\n\t\t\tflex: 1;\n\t\t\tword-break: break-word;\n\t\t\tdisplay: -webkit-box;\n\t\t\t-webkit-line-clamp: 2;\n\t\t\t-webkit-box-orient: vertical;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 110%;\n\t\t\tletter-spacing: 0;\n\t\t\tcolor: #656564;\n\t\t}\n\t}\n}\n\n.spinner-wrapper {\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
